module.exports = __webpack_public_path__ + "img/shuffle.db2a8063.svg";